function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.9311 5.67916C18.8856 5.57812 18.82 5.4875 18.7378 5.41042L14.2933 1.24375C14.1267 1.08854 13.9011 1.00104 13.6667 1H3.88889C3.39777 1 3 1.37291 3 1.83333V20.1667C3 20.3875 3.09333 20.6 3.26 20.7562C3.42667 20.9125 3.65333 21 3.88888 21H18.1111C18.3467 21 18.5733 20.9125 18.74 20.7562C18.9067 20.6 19 20.3875 19 20.1667V6C19 5.88959 18.9767 5.78125 18.9311 5.67918L18.9311 5.67916ZM14.5555 3.84479L15.9655 5.16666H14.5555V3.84479ZM17.2222 19.3333H4.77772V2.66666H12.7777V5.99999C12.7777 6.22082 12.8711 6.43332 13.0377 6.58956C13.2044 6.74582 13.4311 6.83331 13.6666 6.83331H17.2222L17.2222 19.3333Z"
});

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.26686 7H9.4002C9.98954 7 10.4669 6.55251 10.4669 6C10.4669 5.44749 9.98954 5 9.4002 5H7.26686C6.67752 5 6.2002 5.44749 6.2002 6C6.2002 6.55251 6.67752 7 7.26686 7Z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.20021 11C6.20021 11.265 6.30101 11.52 6.48101 11.7075C6.66101 11.895 6.9058 12 7.1602 12H14.8402C15.3706 12 15.8002 11.5525 15.8002 11C15.8002 10.4475 15.3706 10 14.8402 10H7.1602C6.62978 10 6.2002 10.4475 6.2002 11L6.20021 11Z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.8402 15H7.1602C6.62978 15 6.2002 15.4475 6.2002 16C6.2002 16.5525 6.62978 17 7.1602 17H14.8402C15.3706 17 15.8002 16.5525 15.8002 16C15.8002 15.4475 15.3706 15 14.8402 15Z"
});

var SvgDocument = function SvgDocument(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref, _ref2, _ref3, _ref4)
  );
};

export default SvgDocument;